import type * as Types from '../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateCompanySensorGroupsMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  sensorGroups: Types.AccountsCompanySensorGroupsInput;
}>;


export type UpdateCompanySensorGroupsMutationPage = { readonly __typename?: 'RootMutationType', readonly updateCompanySensorGroups: boolean };

export type CreateCopySensorGroupsOrderMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.TeamNotificationsCopySensorGroupsInput;
}>;


export type CreateCopySensorGroupsOrderMutationPage = { readonly __typename?: 'RootMutationType', readonly createCopySensorGroupsOrder: boolean };


export const UpdateCompanySensorGroupsDocument = gql`
    mutation UpdateCompanySensorGroups($id: ID!, $sensorGroups: AccountsCompanySensorGroupsInput!) {
  updateCompanySensorGroups(id: $id, sensorGroups: $sensorGroups)
}
    `;
export type UpdateCompanySensorGroupsMutationFn = Apollo.MutationFunction<UpdateCompanySensorGroupsMutationPage, UpdateCompanySensorGroupsMutationVariables>;

/**
 * __useUpdateCompanySensorGroupsMutation__
 *
 * To run a mutation, you first call `useUpdateCompanySensorGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanySensorGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanySensorGroupsMutation, { data, loading, error }] = useUpdateCompanySensorGroupsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sensorGroups: // value for 'sensorGroups'
 *   },
 * });
 */
export function useUpdateCompanySensorGroupsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanySensorGroupsMutationPage, UpdateCompanySensorGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanySensorGroupsMutationPage, UpdateCompanySensorGroupsMutationVariables>(UpdateCompanySensorGroupsDocument, options);
      }
export type UpdateCompanySensorGroupsMutationHookResult = ReturnType<typeof useUpdateCompanySensorGroupsMutation>;
export type UpdateCompanySensorGroupsMutationResult = Apollo.MutationResult<UpdateCompanySensorGroupsMutationPage>;
export type UpdateCompanySensorGroupsMutationOptions = Apollo.BaseMutationOptions<UpdateCompanySensorGroupsMutationPage, UpdateCompanySensorGroupsMutationVariables>;
export const CreateCopySensorGroupsOrderDocument = gql`
    mutation CreateCopySensorGroupsOrder($companyId: ID!, $input: TeamNotificationsCopySensorGroupsInput!) {
  createCopySensorGroupsOrder(companyId: $companyId, input: $input)
}
    `;
export type CreateCopySensorGroupsOrderMutationFn = Apollo.MutationFunction<CreateCopySensorGroupsOrderMutationPage, CreateCopySensorGroupsOrderMutationVariables>;

/**
 * __useCreateCopySensorGroupsOrderMutation__
 *
 * To run a mutation, you first call `useCreateCopySensorGroupsOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCopySensorGroupsOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCopySensorGroupsOrderMutation, { data, loading, error }] = useCreateCopySensorGroupsOrderMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCopySensorGroupsOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateCopySensorGroupsOrderMutationPage, CreateCopySensorGroupsOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCopySensorGroupsOrderMutationPage, CreateCopySensorGroupsOrderMutationVariables>(CreateCopySensorGroupsOrderDocument, options);
      }
export type CreateCopySensorGroupsOrderMutationHookResult = ReturnType<typeof useCreateCopySensorGroupsOrderMutation>;
export type CreateCopySensorGroupsOrderMutationResult = Apollo.MutationResult<CreateCopySensorGroupsOrderMutationPage>;
export type CreateCopySensorGroupsOrderMutationOptions = Apollo.BaseMutationOptions<CreateCopySensorGroupsOrderMutationPage, CreateCopySensorGroupsOrderMutationVariables>;